import { App } from '@grafikr/components';

import './css/app.css';
import 'vendor/lazysizes';

import components from 'framework/components';
import state from 'framework/state';

import 'pages/product/recently-viewed';
import 'pages/global/measurement-conversion';
import 'utils/form-analytics';
import 'utils/shopify-forms-embed';

const app = new App();

components(app);
state(app);
app.mount();

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`);

  if (section) {
    app.mount(section);
  }
});
